module.exports = __webpack_public_path__ + "static/media/redhair.c12119c1.png";